<ion-grid class="ion-no-padding">
  <ion-row class="ion-justify-content-end">
    <ion-col class="info-column" size="auto" *ngIf="ratingSummary?.reviewCount > 0 && ratingSummary?.ratingAvg >= 3.5">
      <ion-row class="title ratings">
        <app-rating class="margin-right-4" [rate]="ratingSummary.ratingAvg"></app-rating>
        <aaa-text i18n>{{ ratingSummary.ratingAvg | number:'1.0-1' }}</aaa-text>
      </ion-row>
      <ion-row class="ion-justify-content-end">
        <app-reviews-count [numberReviews]="ratingSummary.reviewCount"></app-reviews-count>
      </ion-row>
    </ion-col>
  </ion-row>
</ion-grid>
